import { UsersService } from '../../../services/users';

/**
 * returns a display text for a blocker name (if no IAM-ID)
 * @param createdBy the stored "user-identifier" who blocked or unblocked the affected user
 */
export const getAutomaticBlockerName = (
  createdBy: string
): string | undefined => {
  switch (createdBy) {
    case 'SUB.Service':
    case 'subservice':
      return 'Automatic (SUB.Service)';
    case 'external_event':
      return 'Automatic (Netsuite)';
    case 'unknown':
      return 'Unknown blocker';
    default:
      return undefined;
  }
};

export const getNameOfBlocker = async (userId: string) => {
  const isAutomaticBlocker = getAutomaticBlockerName(userId);
  if (isAutomaticBlocker) {
    return isAutomaticBlocker;
  }
  return await UsersService.getById({ userId })
    .then((info) => {
      return info.first_name === undefined || info.last_name === undefined
        ? info.email !== undefined
          ? info.email
          : userId
        : `${info.first_name} ${info.last_name}`;
    })
    .catch(() => {
      return 'Unknown blocker';
    });
};
